// Menu library
export const MENU_LIBRARY_ITEMS_ROUTE = "/menu-library/items";
export const MENU_LIBRARY_MENUS_ROUTE = "/menu-library/menus";
export const MENU_LIBRARY_ITEM_PREVIEW_ROUTE = "/menu-library/items/[itemId]";
export const MENU_LIBRARY_MENU_PREVIEW_ROUTE = "/menu-library/menus/[menuId]";

// Inquiry
export const INQUIRIES_ROUTE = "/inquiries";
export const INQUIRY_DETAILS_ROUTE = "/inquiries/[inquiryId]";
export const SHARE_INQUIRY_ROUTE = "/share/inquiry-form/[id]";

// Clients
export const CLIENTS_ROUTE = "/clients";
export const CLIENT_PREVIEW_ROUTE = "/clients/[clientId]";
export const CLIENT_DETAILS_ROUTE = "/clients/[clientId]/details";
export const CLIENT_EVENTS_ROUTE = "/clients/[clientId]/events";
export const CLIENT_MENUS_ROUTE = "/clients/[clientId]/menus";
export const CLIENT_INTAKE_FORMS_ROUTE = "/clients/[clientId]/intake-forms";

// Profile
export const PROFILE_ROUTE = "/profile";
export const PROFILE_OVERVIEW_ROUTE = "/profile/overview";
export const PROFILE_ADVANCED_ROUTE = "/profile/advanced";
export const PROFILE_SUBSCRIPTIONS_ROUTE = "/profile/subscriptions";
export const PROFILE_REFERRAL_PROGRAM_ROUTE = "/profile/referral-program";
export const PROFILE_QUESTIONNAIRE_ROUTE = "/profile/questionnaire";
export const PROFILE_TERMS_CONDITIONS_ROUTE = "/profile/terms-conditions";
export const PROFILE_FAQ_ROUTE = "/profile/faq";

// Calendar
export const CALENDAR_ROUTE = "/calendar";
export const PROFILE_CALENDAR_SUBSCRIPTION_ROUTE =
  "/profile/calendar-subscription";

// Events
export const EVENTS_ROUTE = "/events";
export const EVENT_ROUTE = "/events/[eventId]";
export const EVENT_OVERVIEW_ROUTE = "/events/[eventId]/overview";
export const EVENT_CONSULTATION_FORM_ROUTE =
  "/events/[eventId]/consultation-form";
export const EVENT_CONSULTATION_FORM_EDIT_ROUTE =
  "/events/[eventId]/consultation-form/edit";
export const EVENT_CONSULTATION_FORM_COMPLETE_ROUTE =
  "/events/[eventId]/consultation-form/complete";
export const EVENT_CONTRACTS_AND_PROPOSALS_ROUTE =
  "/events/[eventId]/contracts-and-proposals";
export const EVENT_MENU_ROUTE = "/events/[eventId]/menu";
export const EVENT_MENU_EDIT_ROUTE = "/events/[eventId]/menu/edit";
export const EVENT_RECIPES_ROUTE = "/events/[eventId]/recipes";
export const EVENT_CHAT_ROUTE = "/events/[eventId]/chat";
export const EVENT_INVOICE_ROUTE = "/events/[eventId]/invoice";
export const EVENT_ACTIVITY_ROUTE = "/events/[eventId]/activity";

// Client View
export const CLIENT_VIEW_EVENT_ROUTE = "/client/[hash]/events/[eventId]";
export const CLIENT_VIEW_EVENT_MENU_ROUTE =
  "/client/[hash]/events/[eventId]/menu";
export const CLIENT_VIEW_EVENT_CONSULTATION_FORM_ROUTE =
  "/client/[hash]/events/[eventId]/consultation-form";
export const CLIENT_VIEW_EVENT_CONSULTATION_FORM_COMPLETE_ROUTE =
  "/client/[hash]/events/[eventId]/consultation-form/complete";
export const CLIENT_VIEW_EVENT_PROPOSAL_ROUTE =
  "/client/[hash]/events/[eventId]/proposal";
export const CLIENT_VIEW_EVENT_INVOICE_ROUTE =
  "/client/[hash]/events/[eventId]/invoice";
export const CLIENT_VIEW_EVENT_CHAT_ROUTE =
  "/client/[hash]/events/[eventId]/chat";
export const CLIENT_VIEW_EVENT_PAYMENT_INVOICE_ROUTE =
  "/client/[hash]/events/[eventId]/payment/invoice";
export const CLIENT_VIEW_EVENT_PAYMENT_PROPOSAL_ROUTE =
  "/client/[hash]/events/[eventId]/payment/proposal";

// Subscriptions
export const SUBSCRIPTIONS_PLANS_ROUTE = "/subscriptions/plans";
export const SUBSCRIPTIONS_PAYMENT_ROUTE = "/subscriptions/payment";
export const SUBSCRIPTIONS_SUCCESS_ROUTE = "/subscriptions/success";
export const SUBSCRIPTIONS_ORDERS_PURCHASED_ROUTE =
  "/subscriptions/orders-purchased";

// Onboarding
export const PERSONAL_DATA_ROUTE = "/personal-data";

// Admin Panel
export const ADMIN_PANEL_ROUTE = "/admin-panel";
export const ADMIN_PANEL_ANALYTICS_ROUTE = "/admin-panel/analytics";
export const ADMIN_PANEL_CUSTOMERS_ROUTE = "/admin-panel/customers";
export const ADMIN_PANEL_CUSTOMER_ROUTE = "/admin-panel/customers/[customerId]";
export const ADMIN_PANEL_CUSTOMER_OVERVIEW_ROUTE =
  "/admin-panel/customers/[customerId]/overview";
export const ADMIN_PANEL_CUSTOMER_REFERRAL_PROGRAM_ROUTE =
  "/admin-panel/customers/[customerId]/referral-program";
export const ADMIN_PANEL_CUSTOMER_SUBSCRIPTION_ROUTE =
  "/admin-panel/customers/[customerId]/subscription";
export const ADMIN_PANEL_GROUP_BUYING_ROUTE = "/admin-panel/group-buying";
export const ADMIN_PANEL_DEMO_REQUESTS_ROUTE = "/admin-panel/demo-requests";
